class NumberFormatter {
	static pad(input, padLength = 2) {
		return String(input).padStart(padLength, '0')
	}
}

export default NumberFormatter;
